import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { whenPageActivated } from './app/core/navigation/prerender-activation';
import { environment } from './environments/environment';

const originalWarn = console.warn;

console.warn = (...args: any[]) => {
  const excludeWarnings: string[] = ['NG0912', '[webpack-dev-server]'];
  if (typeof args[0] === 'string' && excludeWarnings.some(keyword => args[0].includes(keyword))) {
    // Don't show warning
    return;
  }
  originalWarn(...args);
};

if (environment.production) {
  enableProdMode();
}

// A prerendered page must not start the Shell: its session storage (deeplink, Okta sign-in) would be discarded
whenPageActivated()
  .then(() => platformBrowserDynamic().bootstrapModule(AppModule))
  .catch(err => console.error(err));
